import React from 'react';
import AuthorityManagement from '../../../components/authority/AuthorityManagement';
import LocationManagement from '../../../components/location/LocationManagement';
import FunctionManagement from '../../../components/function/FunctionManagement';
import UserManagementIntegration from '../../../components/user_integration/UserManagement';
import OrganogramTab from '../../../components/organization/OrganogramTab';
import AdminRoleManagement from '../../../components/admin-role/AdminRoleManagementLive';
import ITGCHub from '../../../components/itgc/ITGCHub';
// ActivityManagement moved to Organisation → Masters → System (see OrgMasters).
// PostingManagement is now mounted inside OrganogramTab as "HR Postings".
import OrganizationProfile from '../../../components/organization/OrganizationProfile';
import OrgMasters from '../../../components/organization/OrgMasters';
import CadenceRuleList from '../../../components/cadence/CadenceRuleList';
import { CADENCE_MODULE_TYPES } from '../../../components/cadence/cadenceModuleTypes';
// PopulationMaster moved into Organisation → Masters → Audit (see OrgMasters).
import '../../../components/layout/ModuleLayout.css';
import { OrgTabKey } from './OrganisationTabs';

interface OrganisationNetBodyProps {
  activeTab?: OrgTabKey;
}

const OrganisationNetBody: React.FC<OrganisationNetBodyProps> = ({ activeTab = 'authority' }) => {
  const renderPanel = () => {
    if (activeTab === 'profile')       return <OrganizationProfile />;
    if (activeTab === 'authority')     return <div className="authority-wrapper"><AuthorityManagement compact /></div>;
    if (activeTab === 'functions')     return <div className="function-wrapper"><FunctionManagement compact /></div>;
    if (activeTab === 'locations')     return <div className="location-wrapper"><LocationManagement compact /></div>;
    if (activeTab === 'organogram')    return <div className="position-wrapper" style={{ height: '100%' }}><OrganogramTab /></div>;
    if (activeTab === 'adminroles')    return <div className="admin-role-wrapper"><AdminRoleManagement compact /></div>;
    if (activeTab === 'itgc')          return <div className="itgc-wrapper" style={{ height: '100%' }}><ITGCHub /></div>;
    if (activeTab === 'users')         return <div className="user-wrapper"><UserManagementIntegration compact /></div>;
    if (activeTab === 'masters')       return <div className="masters-wrapper" style={{ height: '100%' }}><OrgMasters /></div>;
    if (activeTab === 'cadence')       return <div className="cadence-wrapper" style={{ height: '100%' }}><CadenceRuleList allowedTypeCodes={CADENCE_MODULE_TYPES.organization} /></div>;
    return (
      <div className="coming-soon">
        <span className="soon-badge">Coming soon</span>
        <p>This placeholder establishes navigation scope. Functionality will be implemented in phases.</p>
      </div>
    );
  };

  return (
    <div className="module-layout">
      <div className="module-main">
        <div className="tab-content">
          <section role="tabpanel" className="tab-panel show">
            {renderPanel()}
          </section>
        </div>
      </div>
    </div>
  );
};

export default OrganisationNetBody;
